import React from "react";

export const SocialYouTubeIcon = () => (
    <i className="icon ion-social-youtube-outline" />
);
